import { types } from 'mobx-state-tree';

export const TicketBetStore = types
    .model('ticketBetStore', {
        combinationCount: types.maybeNull(types.number),
        selectedSystem: types.maybeNull(types.number),
        systemStake: types.maybeNull(types.number),
        unitStake: types.maybeNull(types.number),
        selectionCount: types.maybeNull(types.number),
    })